import React from 'react'
import '../styles/About.css'
export default function About() {
    return (
        <div className='About_container'id="About_container">
            <fieldset>
                <legend>A word from founders.</legend>
                <p>We are totally facinated by the concept QR codes.
                  We absolutely loved to scan QRs,they are like a totally different way to store information which looks like some modern futuristic tech!!.  The core reason behind a full blown NFT project is its flexibility on sharing almost anything on the digital world, And the 2nd most eating reason is using it a secret language. Imaging going in a club with a QR printed on your shirt, will you never know who adds you up. Tattooing QR which is a quote by your favourite athlete.Banners loaded with QRs taking you to there Christmas sale.</p>
            </fieldset>
        </div>
    )
}
